<template>
  <div :class="$device.isDesktop ? 'border': ''" class="flex flex-col gap-3 bg-white rounded-lg p-3 mb-3">
    <div class="flex justify-between gap-2">
      <div class="flex flex-col">
        <div v-if="$device.isDesktop" class="flex-center gap-2 mb-3">
          <van-rate :model-value="review?.rating" allow-half color="#222" readonly size="14" void-color="#cecece"
                    void-icon="star"/>
        </div>
        <div class="flex gap-3">
          <div class="font-bold">{{ review.author }}</div>
          <div v-if="review.order_product"
               class="flex items-center text-secondary bg-secondary-light rounded-full px-2 h-[16px]">
            <van-icon :name="$publicPath('/images/check-secondary.svg')" class="me-1" color="#222" size="14"/>
            <div class="text-xss">{{ $t('product.reviews.has_purchased') }}</div>
          </div>
        </div>
        <div class="text-xs font-light">{{ review.date_added }}</div>
      </div>
      <div v-if="!$device.isDesktop" class="flex flex-col align-center gap-1 justify-center">
        <van-rate :model-value="review?.rating" allow-half color="#222" readonly size="14" void-color="#cecece"
                  void-icon="star"/>
      </div>
    </div>

    <div class="flex justify-between items-end">
      <div class="text-sm break-words max-w-[80%]" v-html="review?.text"></div>

      <div v-if="!hasReviews" class="flex items-center gap-2 ps-1">
        <like :product="product" :review="review"/>
        <reply v-if="!hideReply" :review="review" @click="toggleReviewBox"/>
      </div>
    </div>

    <div v-if="hasReviews" class="flex justify-between gap-3 w-full">
      <div class="max-w-[80%]">
        <attachments :attachments="review.attachments"/>
      </div>
      <div class="flex items-end gap-2">
        <like :product="product" :review="review"/>
        <reply v-if="!hideReply" :review="review" @click="toggleReviewBox"/>
      </div>
    </div>

    <reply-box v-if="isReplyShown" :comments="comments" :index="index" :product="product"
               :review="review" @hide="isReplyShown = false"/>
  </div>
</template>

<script setup>
import Attachments from "@/components/product/reviews/Attachments";
import Like from "@/components/product/reviews/Like";
import Reply from "@/components/product/reviews/ReviewReply";
import ReplyBox from "@/components/product/reviews/ReplyBox";
import {getCommentsByReviewId} from "@/plugins/API/review";

const props = defineProps({
  review: {
    type: Object,
    default: () => {
    }
  },
  product: {
    type: Object,
    default: () => {
    }
  },
  index: {
    type: Number,
    default: 0
  },
  hideReply: {
    type: Boolean,
    default: false
  },
  hideAttachments: {
    type: Boolean,
    default: false
  }
})

const isReplyShown = ref(false)

const hasReviews = computed(() => props?.review?.attachments?.length && !props.hideAttachments)

const toggleReviewBox = () => {
  isReplyShown.value = !isReplyShown.value
  isReplyShown.value && getSubComments(props.review?.review_id)
}

const comments = ref([])
const {isLoading, mutateAsync: commentsMutateAsync} = getCommentsByReviewId();
const getSubComments = (review_id) => {
  commentsMutateAsync(review_id).then(({data}) => {
    comments.value = data?.comments || []
  });
}
</script>

<style scoped>

</style>